import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const CommentWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.default.color.text.medium};
  background-color: ${({ theme }) => theme.default.color.backgrounds.light};
  padding: 10px;
  margin-top: 22px;
  p {
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 8px;
    max-width: 85%;
  }
  .author {
    color: ${({ theme }) => theme.default.color.primary};
    font-weight: 600;
  }
`;

export const Grid = styled.div`
  display: grid;
  column-gap: 15px;
  grid-template-columns: 48px 1fr;
  row-gap: 0.4rem;
`;


